export default __webpack_public_path__ + "static/media/Railway.b475d4e1.jpeg";